<template>
  <v-app class="cleano-app">
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
.cleano-app.v-application,
.cleano-app .v-main { background: #070a10 !important; }
.cleano-app.v-application { font-family: 'Syne', -apple-system, BlinkMacSystemFont, sans-serif; }
</style>
